<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo">
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <p class="font-semibold">{{ activeUserInfo.Name }}</p>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="profile">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import UserService from "@/services/UserService";

export default {
  computed: {
    activeUserInfo () {
      return JSON.parse(localStorage.getItem("userInfo")) || this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout () {
       UserService.logoutWithFirebase((err, data) => {
        localStorage.removeItem('userInfo')
  
        this.$router.push('/pages/login').catch(() => {})
      });
    },
    profile () {      
      this.$router.push('/apps/users/profile').catch(() => {})
    }
  }
}
</script>
